import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/show_activity_qr_bg.jpg'


const _withScopeId = n => (_pushScopeId("data-v-b76f5b58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "activity-share" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bg",
  src: _imports_0,
  alt: "bg"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "推广活动", -1))
const _hoisted_4 = { class: "desc" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "footer"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityShareView',
  props: {
    activityId: {},
    isEdit: { type: Boolean },
    title: {}
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_flex, {
      vertical: "",
      align: "center",
      class: "header"
    }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1)
      ]),
      _: 1
    }),
    _createElementVNode("img", {
      class: "qr",
      src: `https://api.activity.djhdb.cn/pc/open/qr/activity?id=${_ctx.activityId}`,
      alt: "qr"
    }, null, 8, _hoisted_5),
    (_ctx.isEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_router_link, { to: "/activities" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                size: "large",
                shape: "round"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("我的活动")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: '/activities/activity?activity_id='+_ctx.activityId
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                size: "large",
                shape: "round",
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("报表与跟进 ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})